import { styled } from 'stitches.config'

export const DigestiveBenefitsRoot = styled('div', {
  width: '100%',
  background: '$accent-white',
  padding: '64px 0px',

  '@bp2': {
    padding: '77px 0px',
  },

  '& span': {
    display: 'inline'
  }
})

export const Header = styled('h2', {
  fontSize: '$h3',
  letterSpacing: '$h3',
  lineHeight: '$h3',
  textAlign: 'center',
  margin: 'auto',
  marginBottom: '24px',
  padding: '0 $2',
  '@bp2': {
    fontSize: '$h1',
    letterSpacing: '$h1',
    lineHeight: '$h1',
    marginBottom: '42px',
  },
})

export const DigestiveBenefitsContainer = styled('div', {})
export const ButtonWrapper = styled('div', {
  marginTop: '42px',
  display: 'flex',
  justifyContent: 'center',
  '@bp2': {
    justifyContent: 'flex-start',
  },
})
